module.exports = __webpack_public_path__ + "static/antd-table-colspan-31097a65809f47372b29556f65eaecbd.png";